import { Badge } from "@/components/ui/badge"
import { cn } from "@/lib/utils"

export interface AssetStateChipProps {
  /** Derived, server-side asset state (see asset-library Tier-1 contract). */
  state: string
  className?: string
}

interface StateStyle {
  label: string
  /** Theme-token-only tone classes (no hardcoded hex / raw palette). */
  tone: string
}

const MUTED_TONE = "bg-muted text-muted-foreground border-transparent"

const STATE_STYLES: Record<string, StateStyle> = {
  "web-ready": {
    label: "Web-ready",
    tone: "bg-teal-light text-teal-dark border-teal/20",
  },
  "source-only": {
    label: "Source file",
    tone: MUTED_TONE,
  },
  "needs-review": {
    label: "Needs review",
    tone: "bg-coral-light text-coral-dark border-coral/20",
  },
  "do-not-use": {
    label: "Do not use",
    tone: "bg-destructive/10 text-destructive border-transparent",
  },
  archived: {
    label: "Archived",
    tone: MUTED_TONE,
  },
  // Reserved for the future derivative pipeline; Tier-1 does not emit these,
  // but the chip styles them with a muted fallback so they render gracefully.
  "needs-derivative": {
    label: "Needs derivative",
    tone: MUTED_TONE,
  },
  "unsupported-preview": {
    label: "No preview",
    tone: MUTED_TONE,
  },
}

export function AssetStateChip({ state, className }: AssetStateChipProps) {
  const style = STATE_STYLES[state] ?? { label: state, tone: MUTED_TONE }

  return (
    <Badge className={cn(style.tone, className)}>{style.label}</Badge>
  )
}

export default AssetStateChip
